import { required } from 'vuelidate/lib/validators'

const requiredMsg = 'Обязательное поле'

export default (vars) => {
  return {
    title: { required: { validator: required, message: requiredMsg } },
    location: { required: { validator: required, message: requiredMsg } }

  }
}
